<div class="dialog-policy-content">
  <pdf-viewer [src]="pdfSrc" [render-text]="true" style="display: block;" [original-size]="false"></pdf-viewer>
</div>
<div class="d-flex justify-content-center mt-2">
  <input type="checkbox" id="termsCheckbox" [(ngModel)]="isChecked">
  <label for="termsCheckbox" class="mt-2 ml-2">Eu li e aceito os termos</label>
</div>
<div class="d-flex justify-content-center">
  <button mat-button (click)="onAccept()" [disabled]="!isChecked" class="btn btn-gtex w-50 mt-2">Aceitar</button>
</div>
